module.exports = __webpack_public_path__ + "img/60.c5e6d5cd.png";